// @flow

export const TRACKING_EVENTS = {
  PAGE_VIEWED: 'page_viewed',
  PRODUCT_VIEWED: 'product_viewed',
  PRODUCT_CART_ADDED: 'product_cart_added',
  PRODUCT_WISHLIST_ADDED: 'product_wishlist_added',
  CHAT_WIDGET_OPENED: 'chat_widget_opened',
};



// WEBPACK FOOTER //
// ./src/lib/trackingEvents.js